module.exports = __webpack_public_path__ + "static/media/bewiseloading.a03e9765.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bewiseloading.gif
// module id = 48
// module chunks = 0